import React, { FC } from 'react'
import styled from 'styled-components'
import { DescriptionTextStyled, SecondaryHeaderStyled } from '../../styles/shared'
import TextWithLinkStyled from '../common/textWithLinkStyled'
import { ScreenBreakpointSize } from '../../utils/enums'
import { getScreenBreakpointSize } from '../../utils/getScreenBreakpointSize'
import { StaticImage } from 'gatsby-plugin-image'

const ContainerStyled = styled.div`
  background-color: var(--background-gray);
  border: 1px solid var(--border-gray);
  border-radius: var(--border-radius-8);
  margin-left: var(--spacing-16);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    border-radius: 0;
    border-right: none;
    border-left: none;
    margin-left: 0;
    margin-right: 0;
  }
`

const HighlightedTextStyled = styled.span`
  font-weight: bold;
  border-bottom: 2px solid var(--corn);
`

const TextContent = styled.div`
  padding: var(--spacing-32) var(--spacing-32);
  align-self: end;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
  }
`

const CustomSectionTitleStyled = styled(SecondaryHeaderStyled)`
  font-size: var(--font-size-28);
`
const CustomDescriptionTextStyled = styled(DescriptionTextStyled)`
  margin-bottom: var(--spacing-16);
  margin-top: var(--spacing-16);
`
const LinkContainerStyled = styled.div`
  width: fit-content;
`

const KeepYourDataProtected: FC = () => {
  return (
    <ContainerStyled>
      <StaticImage
        alt="Squares With Some Locks Image"
        aria-hidden="true"
        src={'../../assets/images/cyborg-library.jpg'}
      />
      <TextContent>
        <div>
          <CustomSectionTitleStyled>
            <HighlightedTextStyled>Your</HighlightedTextStyled> notes and files, always.
          </CustomSectionTitleStyled>
          <CustomDescriptionTextStyled>
            Never worry about losing your data again. You'll always have an offline copy of your data, so you can access
            your notes and files even without an internet connection.
          </CustomDescriptionTextStyled>
          <CustomDescriptionTextStyled>
            Automated backups and secure cloud sync ensure that your data is safe and sound, even if your device is
            lost, damaged, or stolen.
          </CustomDescriptionTextStyled>
        </div>
        <LinkContainerStyled>
          <TextWithLinkStyled text={'View our plans'} targetUrl={'/plans'} />
        </LinkContainerStyled>
      </TextContent>
    </ContainerStyled>
  )
}

export default KeepYourDataProtected
